<template>
    <svg width="15" height="15" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.36602 10.5C6.98112 11.1667 6.01887 11.1667 5.63397 10.5L0.870833 2.25C0.485933 1.58333 0.967059 0.750001 1.73686 0.750001L11.2631 0.75C12.0329 0.75 12.5141 1.58333 12.1292 2.25L7.36602 10.5Z" fill="#ffffff"/>
    </svg>
</template>
